import React from 'react';
import { IVisitorSummaryPageProps } from './types';
import { Container, Row, Col, Image } from 'react-bootstrap';
import { FormHeading, Well } from '../../form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Avatar,
  VisitorDetails,
  VisitorDetailsRightColumn,
  VisitorName,
  Icon,
  AlertIcon,
  SectionHeading,
  Question,
  QuestionText,
} from './VisitorSummaryPage.styled';

const VisitorSummaryPage: React.FC<IVisitorSummaryPageProps> = ({
  badgeDescription,
  visitorType,
  name,
  company,
  host,
  inAt,
  outAt,
  carRegistration,
  emailAddress,
  mobile,
  triggeredQuestionnaireAlert,
  questionnaires,
  agreement,
  digitalSignature,
}) => {
  return (
    <Container>
      <Well>
        <FormHeading title="Visitor Summary" showBackButton />
        <div>
          <Row>
            <Col>
              <VisitorDetails>
                <Avatar>
                  <FontAwesomeIcon icon={visitorType.icon} size="5x" />
                </Avatar>
                <VisitorDetailsRightColumn>
                  <VisitorName>{name}</VisitorName>
                  <div className="text-truncate">{company}</div>
                  <small>{badgeDescription}</small>
                </VisitorDetailsRightColumn>
              </VisitorDetails>
            </Col>
          </Row>
          <Row className="mt-5">
            <Col xl={6}>
              <Row as="dl">
                <Col as="dt" md={4}>
                  <Icon icon={['far', 'arrow-right']} />
                  In
                </Col>
                <Col as="dd" md={8}>
                  {inAt}
                </Col>

                <Col as="dt" md={4}>
                  <Icon icon={['far', 'arrow-left']} />
                  Out
                </Col>
                <Col as="dd" md={8}>
                  {outAt}
                </Col>

                <Col as="dt" md={4}>
                  <Icon icon="user-tie" />
                  Host
                </Col>
                <Col as="dd" md={8}>
                  {host}
                </Col>

                <Col as="dt" md={4}>
                  <Icon icon="user-hard-hat" />
                  Visitor Type
                </Col>
                <Col as="dd" md={8}>
                  {visitorType.name}
                </Col>

                <Col as="dt" md={4}>
                  <Icon icon="exclamation-triangle" />
                  Alert
                </Col>
                <Col as="dd" md={8}>
                  {triggeredQuestionnaireAlert ? (
                    <span className="text-danger">Yes</span>
                  ) : (
                    <span>No</span>
                  )}
                </Col>
              </Row>
            </Col>

            <Col xl={6}>
              <Row as="dl">
                {carRegistration && (
                  <>
                    <Col as="dt" md={4}>
                      <Icon icon="car" />
                      Car Registration
                    </Col>
                    <Col as="dd" md={8}>
                      {carRegistration}
                    </Col>
                  </>
                )}

                {emailAddress && (
                  <>
                    <Col as="dt" md={4}>
                      <Icon icon="envelope" />
                      Email
                    </Col>
                    <Col as="dd" md={8}>
                      {emailAddress}
                    </Col>
                  </>
                )}

                {mobile && (
                  <>
                    <Col as="dt" md={4}>
                      <Icon icon="phone" />
                      Mobile
                    </Col>
                    <Col as="dd" md={8}>
                      {mobile}
                    </Col>
                  </>
                )}

                <Col as="dt" md={4}>
                  <Icon icon="id-badge" />
                  Badge
                </Col>
                <Col as="dd" md={8}>
                  {badgeDescription}
                </Col>
              </Row>
            </Col>
          </Row>

          {questionnaires.length > 0 && (
            <Row className="mt-4">
              <Col>
                {questionnaires.map((section) => (
                  <div key={section.heading}>
                    <SectionHeading>{section.heading}</SectionHeading>
                    {section.questions.map((answer) => (
                      <div key={answer.text}>
                        <Question>
                          <Row>
                            <Col md={10}>
                              <QuestionText>{answer.text}</QuestionText>
                              {answer.triggeredAlert && answer.alert && (
                                <div className="blockquote-footer text-danger">
                                  {answer.alert}
                                </div>
                              )}
                            </Col>
                            <Col md={2}>
                              {answer.answer}
                              {answer.triggeredAlert && (
                                <AlertIcon
                                  icon="exclamation-triangle"
                                  className="text-warning"
                                />
                              )}
                            </Col>
                          </Row>
                        </Question>
                      </div>
                    ))}
                  </div>
                ))}
              </Col>
            </Row>
          )}

          {agreement && (
            <div
              className="ck-content"
              dangerouslySetInnerHTML={{ __html: agreement }}
            />
          )}

          {digitalSignature && (
            <Row className="mt-5 text-center">
              <Col>
                <Image fluid src={digitalSignature} alt="signature" />
              </Col>
            </Row>
          )}
        </div>
      </Well>
    </Container>
  );
};

export default VisitorSummaryPage;
